export const PRIVACY_ROUTE = '/privacy'

export const privacySeo = {
  title: 'Privacy policy | SecureFix',
  description:
    'How SECUREFIX LTD uses name, email, phone, device and fault details sent through the SecureFix forms.',
  path: PRIVACY_ROUTE,
}
